<template>
  <div>
    <template v-for="entry in timeline">
      <AppSafariCard
        v-if="entry.kind === 'day'"
        :key="`day-${entry.index}`"
        :order-number="entry.dayNumber"
        :data="entry.item"
        :is-clearable="isClearable"
        @onCardDelete="$emit('delete', entry.index)"
      />
      <button
        v-else-if="canAddMissing"
        :key="`missing-${entry.date}`"
        type="button"
        class="safari-missing-day"
        @click="$emit('add-missing', entry.date)"
      >
        <span>Day {{ entry.dayNumber }} | {{ formatDate(entry.date) }} · Missing day</span>
        <strong>Add program</strong>
      </button>
      <div v-else :key="`missing-${entry.date}`" class="safari-missing-day">
        Day {{ entry.dayNumber }} | {{ formatDate(entry.date) }} · Missing day
      </div>
    </template>
    <p v-if="validationError" class="safari-itinerary-validation" role="alert">{{ validationError }}</p>
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns'
import AppSafariCard from '@/components/AppSafariCard.vue'
import { safariItineraryTimeline } from '@/utils/safariItineraryDays'

export default {
  name: 'SafariItineraryDayList',
  components: { AppSafariCard },
  props: {
    items: { type: Array, required: true },
    isClearable: { type: Boolean, default: true },
    canAddMissing: { type: Boolean, default: true },
    validationError: { type: String, default: '' },
  },
  computed: {
    timeline() { return safariItineraryTimeline(this.items) },
  },
  methods: {
    formatDate(date) { return format(parseISO(date), 'dd MMM') },
  },
}
</script>

<style scoped lang="sass">
.safari-missing-day
  display: flex
  align-items: center
  justify-content: space-between
  width: 100%
  min-height: 48px
  margin-bottom: 10px
  padding: 10px 12px
  border: 1px dashed #d69b45
  border-radius: 10px
  background: #fffaf1
  color: #6d4a19
  cursor: pointer
  text-align: left

  strong
    color: #356c9b

  &:hover
    background: #fff2dc

.safari-itinerary-validation
  margin: 8px 0 18px
  color: #a14b22
  font-size: 13px
</style>
